"use client";
import React, { CSSProperties, memo, useEffect } from "react";

// TODO - field type is any due to conflict in propety (need to update when free time)
const Input = memo(({
  inputId,
  field,
  style,
  onFocus,
  onBlur,
  onChange,
  autoFocus,
  inputValue,
  showErrors,
  inputError,
  onKeyDown
}: {
  inputId: string
  field: any;
  style?: CSSProperties;
  onFocus: Function;
  onBlur: Function;
  onChange?: Function;
  onKeyDown?: Function;
  autoFocus?: boolean;
  inputValue:string
  showErrors:any;
  inputError?:any;
}) => {

  return (
    <>
    <input
      id={inputId ?? field?.id ?? ""}
      {...(field?.inputType === "checkbox" || field?.inputType === "radio"
            ? { checked: !!inputValue }
            : { value: inputValue })}
      accept=".jpg, .jpeg, .png , .pdf"
      type={field?.inputType ?? "text"}
      style={{ ...(style ?? {}), ...(field?.style ?? {}), cursor: field?.disabled ? "normal" : field?.style?.cursor }}
      placeholder={field?.placeholder ?? ""}
      className={field?.className??""}
      {...(field?.inputType === "date"
        ? { max: new Date().toISOString().split("T")[0] }
        : {})}
      pattern={field?.pattern || ".*"}
      multiple={field?.multiple ?? false}
      {...(field?.maxLength ? { maxLength: field.maxLength } : {})}
      disabled={field?.disabled??false}
      autoComplete={field?.autoComplete !== undefined ? field?.autoComplete : "off"}
      aria-autocomplete={field?.ariaAutocomplete !== undefined ? field?.ariaAutocomplete : "list"}
      aria-expanded={field?.ariaExpanded !== undefined ? field?.ariaExpanded : "false"}
      autoCapitalize={field?.autoCapitalize !== undefined ? field?.autoCapitalize : "none"}
      onChange={(e) => onChange ? onChange(e,"INPUT") : ()=>{}}
      onFocus={(e) => onFocus(e)}
      onBlur={(e) => onBlur(e)}
      onKeyDown={(e) => onKeyDown ? onKeyDown(e) : () => {}}
      autoFocus={field?.autoFocus ?? autoFocus ?? false}
    />
    {showErrors &&
    <label style={{
      color:"#F04438",
      fontSize:"12px",
      ...field.errorMessageStyle,

    }}>{inputError}</label>}
    </>
  );
});

export default Input;
